"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Badge_1 = __importDefault(require("@mui/material/Badge"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const React = __importStar(require("react"));
const styles_1 = require("@mui/material/styles");
const react_router_dom_1 = require("react-router-dom");
const NotificationsNone_1 = __importDefault(require("@mui/icons-material/NotificationsNone"));
const MailOutline_1 = __importDefault(require("@mui/icons-material/MailOutline"));
const KeyboardArrowIcon_1 = __importDefault(require("./KeyboardArrowIcon"));
const useBreakpoints_1 = require("../../utils/useBreakpoints");
const themes_1 = require("../../../themes");
const eqMainTheme_1 = require("../../../themes/eqMainTheme");
const primaryMainSvgFilter = 'invert(10%) sepia(82%) saturate(7095%) hue-rotate(228deg) brightness(92%) contrast(90%)';
const SvgIcon = (0, styles_1.styled)('img')(() => ({
    width: 20,
    height: 20,
    margin: 0,
    marginLeft: themes_1.Spacings.medium4,
    objectFit: 'contain',
}));
const IconDivider = () => (React.createElement(Divider_1.default, { orientation: "vertical", flexItem: true, sx: {
        marginY: themes_1.Spacings.small4,
        marginX: themes_1.Spacings.small3,
        marginTop: themes_1.Spacings.small4,
        borderColor: 'grey.500',
    } }));
const unauthorizedButtonsBase = {
    color: 'black',
    width: 120,
    lineHeight: '1.5',
};
const CustomBadge = ({ invisible, children, }) => (React.createElement(Badge_1.default, { invisible: invisible, variant: "dot", color: "error", classes: { badge: 'header-badge' }, sx: { '.header-badge': { top: -5, right: -5 } } }, children));
const TopBar = ({ isLoggedIn, accountLinks, messages, notifications, buttonsSettings, hideLoginRegister, }) => {
    const [profileAnchorEl, setprofileAnchorEl] = React.useState(null);
    const breakpoints = (0, useBreakpoints_1.useBreakpoints)(['smUp']);
    const theme = (0, styles_1.useTheme)();
    const openProfileMenu = (event) => setprofileAnchorEl(event.currentTarget);
    const closeProfileMenu = () => setprofileAnchorEl(null);
    const MenuIcon = ({ externalUrl, url, hasUnread, icon, }) => (React.createElement(React.Fragment, null,
        React.createElement(IconButton_1.default, Object.assign({ color: "inherit" }, {
            href: externalUrl ? url : undefined,
            to: !externalUrl ? url : undefined,
            component: externalUrl ? 'a' : react_router_dom_1.Link,
        }, { disableTouchRipple: true, disableRipple: true, disableFocusRipple: true }),
            React.createElement(CustomBadge, { invisible: !hasUnread }, icon)),
        breakpoints.smUp && React.createElement(IconDivider, null)));
    if (isLoggedIn)
        return (React.createElement(React.Fragment, null,
            breakpoints.smUp && (React.createElement(MenuIcon, { externalUrl: !!messages.externalUrl, url: messages.url, hasUnread: messages.hasMessages, icon: React.createElement(MailOutline_1.default, { "data-testid": "MessagesOutlinedIcon" }) })),
            React.createElement(MenuIcon, { externalUrl: !!notifications.externalUrl, url: notifications.url, hasUnread: notifications.hasNotifications, icon: React.createElement(NotificationsNone_1.default, { "data-testid": "NotificationsOutlinedIcon" }) }),
            breakpoints.smUp && (React.createElement(React.Fragment, null,
                React.createElement(Button_1.default, { onClick: openProfileMenu, "aria-haspopup": "true", "aria-expanded": profileAnchorEl ? 'true' : undefined, sx: {
                        fontFamily: eqMainTheme_1.fonts.Heavy,
                        letterSpacing: 0,
                        fontSize: 14,
                        '.arrow-icon': {
                            marginLeft: themes_1.Spacings.small,
                            paddingLeft: 0,
                        },
                        '.profile-icon': { marginRight: themes_1.Spacings.small },
                        color: profileAnchorEl ? 'primary.main' : 'black',
                        '&> img': {
                            filter: profileAnchorEl ? primaryMainSvgFilter : 'none',
                        },
                        '&:hover': {
                            backgroundColor: 'grey.200',
                            borderRadius: themes_1.Spacings.small,
                        },
                    }, disableTouchRipple: true, disableFocusRipple: true },
                    React.createElement(SvgIcon, { className: "profile-icon", src: `${theme.baseMediaUrl}/v1/icon-small-user.svg`, alt: "Account" }),
                    "My Account",
                    React.createElement(KeyboardArrowIcon_1.default, { className: "arrow-icon", isOpen: !!profileAnchorEl })))),
            breakpoints.smUp && (React.createElement(Menu_1.default, { anchorEl: profileAnchorEl, open: !!profileAnchorEl, onClose: closeProfileMenu, MenuListProps: {
                    'aria-labelledby': 'basic-button',
                }, sx: {
                    '& .top-bar-menu': {
                        borderRadius: '0px',
                        minWidth: '228px',
                        boxShadow: `0px 5px 5px -3px #e4e5ea, 0px 8px 10px 1px #e4e5ea, 0px 3px 14px 2px #e4e5ea`,
                    },
                }, classes: {
                    paper: 'top-bar-menu',
                } }, accountLinks === null || accountLinks === void 0 ? void 0 : accountLinks.map((link) => (React.createElement(MenuItem_1.default, Object.assign({ onClick: (e) => {
                    if (link.onClick)
                        link.onClick(e);
                    closeProfileMenu();
                } }, {
                href: link.externalUrl ? link.url : undefined,
                to: !link.externalUrl ? link.url : undefined,
                component: link.externalUrl ? 'a' : react_router_dom_1.Link,
            }, { key: link.label, sx: {
                    justifyContent: 'space-between',
                    fontSize: 14,
                    fontFamily: 'Avenir LT W01_55 Roman1475520',
                    letterSpacing: 0,
                    '&:active': {
                        backgroundColor: 'grey.400',
                    },
                }, disabled: link.disabled, disableTouchRipple: true }),
                link.label,
                ' ',
                link.iconUrl && (React.createElement(SvgIcon, { src: link.iconUrl, alt: link.label })),
                link.icon && React.createElement(link.icon, null))))))));
    return !hideLoginRegister
        ? (breakpoints.smUp && (React.createElement(React.Fragment, null,
            React.createElement(Button_1.default, { href: buttonsSettings.registerLink, onClick: (e) => buttonsSettings.onRegisterClick &&
                    buttonsSettings.onRegisterClick(e), variant: "outlined", sx: Object.assign(Object.assign({}, unauthorizedButtonsBase), { color: 'primary.main' }), "data-testid": "register-button", id: "registerButton" }, buttonsSettings.registerButtonName),
            React.createElement(Button_1.default, { href: buttonsSettings.loginLink, onClick: (e) => buttonsSettings.onLoginClick && buttonsSettings.onLoginClick(e), sx: Object.assign(Object.assign({}, unauthorizedButtonsBase), { marginLeft: themes_1.Spacings.small3, color: 'white' }), variant: "contained", "data-testid": "login-button", id: "loginButton" }, buttonsSettings.loginButtonName)))) ||
            null
        : null;
};
exports.default = TopBar;
